
import { mapGetters } from "vuex";

const LOCAL_KEY = "__ebms_search_history";

export default {
  data() {
    return {
      active: false,

      query: "",
      result: [],
      history: [],

      isLoading: false,
      empty: false,
      timeout: null,
      timeoutDelay: 250,
      source: null,
    };
  },

  computed: {
    ...mapGetters({
      config: "CONFIG/CONFIG",
    }),

    getSortedResult() {
      return this.result.sort((a, b) => {
        if (this.getIsSold(a) && !this.getIsSold(b)) {
          return 1;
        }

        if (!this.getIsSold(a) && this.getIsSold(b)) {
          return -1;
        }

        return 0;
      });
    },
  },

  methods: {
    search() {
      clearTimeout(this.timeout);

      if (this.query) {
        this.cancel();

        this.timeout = setTimeout(async () => {
          this.isLoading = true;
          this.source = this.$axios.CancelToken.source();

          try {
            const items = await this.$axios.$get("search-list", {
              params: {
                query: this.query,
              },
              cancelToken: this.source.token,
            });

            // empty anyway
            this.result = [];

            if (items?.length) {
              this.result = items;
              this.empty = false;
            } else {
              this.empty = true;
            }

            this.isLoading = false;
          } catch (err) {
            this.__logError(err);
            this.reset();
          }
        }, this.timeoutDelay);
      } else {
        this.reset();
        this.cancel();
      }
    },

    reset() {
      this.result = [];
      this.isLoading = false;
      this.empty = false;
    },

    cancel() {
      try {
        this.source.cancel("Request canceled.");
      } catch (err) {}
    },

    saveItemToStorage(item) {
      if (!item.slug) return;

      let items = this.getHistory();

      // remove if already exist
      items = items.filter((i) => i.slug !== item.slug);

      // add to start
      items.unshift({
        slug: item.slug,
        name: item.name,
      });

      this.saveHistory(items);

      this.checkRouteIsCurrent(item);
    },

    checkRouteIsCurrent(item) {
      if (this.$route.params.id === item.id) {
        this.hide();
      }
    },

    checkHistory() {
      this.history = this.getHistory();
    },

    getHistory() {
      let items = window.localStorage.getItem(LOCAL_KEY);

      try {
        items = JSON.parse(items);
        if (!Array.isArray(items)) return [];
        return items.filter((i) => i && i.slug);
      } catch (err) {
        return [];
      }
    },

    saveHistory(items) {
      window.localStorage.setItem(
        LOCAL_KEY,
        JSON.stringify(items.slice(0, 10))
      );
    },

    getIsSold(item) {
      return !item.offers.some((offer) => offer.ignoreCount || offer.count > 0);
    },

    hide() {
      this.$store.commit("CONFIG/SET_IS_SEARCH_ACTIVE", false);
      this.$store.commit("CONFIG/SET_IS_BACK_ACTIVE", false);
    },
  },

  mounted() {
    this.$refs.control.focus();
    this.checkHistory();
  },
};
